import User from '@/models/User'
import * as MutationTypes from './mutation-types'

const state = {
  user: User.from(window.localStorage.getItem('token')),
  showMenu: false
}
const mutations = {
  [MutationTypes.LOGIN] (state) {
    state.user = User.from(window.localStorage.getItem('token'))
    state.showMenu = true
  },
  [MutationTypes.LOGOUT] (state) {
    state.user = null
    state.showMenu = false
  }
}

const getters = {
  currentUser (state) {
    return state.user
  },
  menuStatus (state) {
    return state.showMenu
  }
}

const actions = {
  login ({commit}) {
    commit(MutationTypes.LOGIN)
  },
  logout ({commit}) {
    commit(MutationTypes.LOGOUT)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/auth.js